import React from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../components/Formik/FormikControl'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import { registerUser } from '../actions/auth'
import { useDispatch, useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link, Redirect } from 'react-router-dom'
import { PersonAdd } from '@mui/icons-material'
import { Card, CardContent, useMediaQuery, useTheme } from '@mui/material'

const RegisterScreen = () => {
  const dispatch = useDispatch()

  const theme = useTheme()

  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  const auth = useSelector((state) => state.auth)
  const { isAuthenticated, loading } = auth

  if (isAuthenticated) {
    return <Redirect to="/dashboard" />
  }

  const initialValues = {
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
  }

  const validationSchema = Yup.object({
    name: Yup.string().required('Không được để trống'),
    email: Yup.string()
      .email('Email không đúng')
      .required('Không được để trống'),
    password: Yup.string().required('Không được để trống'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'), ''], 'Mật khẩu không trùng khớp')
      .required('Không được để trống'),
  })

  const onSubmit = async (values, { resetForm }) => {
    const { name, email, password } = values
    dispatch(registerUser({ name, email, password }))
    resetForm({ name: '', email: '', password: '' })
  }

  return (
    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ maxWidth: matchesLG ? '60%' : matchesMD ? '60%' : '80%' }}>
        <CardContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column"
          >
            <Grid item>
              <PersonAdd color='primary' fontSize='large' />
            </Grid>
            <Grid item>
              <Typography variant="h4" gutterBottom style={{ textAlign: 'center', textTransform: 'uppercase' }}>
                Đăng ký tài khoản học sinh
              </Typography>
            </Grid>
            <Grid item>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <FormikControl
                        control="input"
                        type="text"
                        label="Tên tài khoản"
                        name="name"
                        style={{ marginBottom: '1em' }}
                      />
                      <FormikControl
                        control="input"
                        type="email"
                        label="Email"
                        name="email"
                        style={{ marginBottom: '1em' }}
                      />
                      <FormikControl
                        control="input"
                        type="password"
                        label="Mật khẩu"
                        name="password"
                        style={{ marginBottom: '1em' }}
                      />
                      <FormikControl
                        control="input"
                        type="password"
                        label="Xác nhận mật khẩu"
                        name="confirmPassword"
                        style={{ marginBottom: '1em' }}
                      />
                      <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={!formik.isValid}
                        style={{ color: 'white' }}
                      >
                        {loading ? (
                          <CircularProgress color="secondary" />
                        ) : (
                          'Đăng ký'
                        )}
                      </Button>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ margin: '1em 0' }}
                      >
                        <Grid item>
                          <Typography variant="body1">
                            Bạn đã có tài khoản?
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Button
                            component={Link}
                            to="/login"
                            variant="text"
                            style={{
                              fontSize: '1rem',
                              textTransform: 'none',
                              fontWeight: '600',
                            }}
                            disableRipple
                          >
                            Đăng nhập
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

export default RegisterScreen
